import React from 'react';
import Review from '../Review/Review';
import useReviews from './../../hooks/useReviews';

const Reviews = () => {
    const [reviews] = useReviews();
    return (
      <div className="mt-20 grid md:grid-cols-3 gap-5 m-5">
        {reviews.map((review) => (
          <Review key={review.id} review={review} />
        ))}
      </div>
    );
};

export default Reviews; 